export default {
  data() {
    return {
      // 加载状态
      scrollFlag: false,
      isEnd: false,
      // 分页
      pageNum: 1,
      total: 0,
      flag: true,
      filterFlag: false,
      itemList: [],
      includeList: [], // 收录
      yearList: [], // 年份
    };
  },
  mounted() {
    this.$bus.$on("mainScroll", this.handlePager);
  },
  beforeDestroy() {
    this.$bus.$off("mainScroll", this.handlePager);
  },
  methods: {
    handlePager() {
      let containerHeight =
        document.documentElement.clientHeight +
        document.documentElement.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight;
      if (containerHeight + 1 >= scrollHeight && !this.scrollFlag && !this.isEnd) {
        if (this.filterFlag) {
          this.getSearchList({
            ...this.params,
            pageNo: ++this.pageNum,
          });
        } else {
          this.getSearchList({
            ...this.params,
            pageNo: ++this.pageNum,
          });
        }
      }
    },
    async getSearchList(data) {
      this.isEnd = false
      this.scrollFlag = true;
      const resp = await this.$apis.searchServe.getEsList({
        pageSize: 10,
        ...data,
      });
      this.scrollFlag = false;
      let num = data.pageSize ? data.pageSize : 10
      this.total = +resp.data.data.total;
      this.isEnd = this.pageNum >= this.total / num;
      this.itemList.push(...resp.data.data.list);
    },
    handleLearn(index) {
      this.filterFlag = true;
      if (this.filterFlag) {
        this.pageNum = 1;
        this.itemList = [];
      }
      this.params.xsjhStatus = index;
      this.getSearchList({
        ...this.params,
      });
    },
    handleLearn1(index) {
      this.filterFlag = true;
      if (this.filterFlag) {
        this.pageNum = 1;
        this.itemList = [];
      }
      this.params.reportCharge = index;
      this.getSearchList({
        ...this.params,
      });
    },
    handleSub(v) {
      this.filterFlag = true;
      if (this.filterFlag) {
        this.pageNum = 1;
        this.itemList = [];
      }
      this.params.classifyNumber = v.classifyNumber;
      this.getSearchList({
        ...this.params,
      });
    },
    handleAll() {
      this.itemList = [];
      this.filterFlag = false;
      this.params.classifyNumber = null;
      this.params.businessId2 = null;
      // 请求全部
      this.getSearchList(this.params);
    },
    handleAll1() {
      this.itemList = [];
      this.filterFlag = false;
      this.params.dataStyle = null;
      // 请求全部
      this.getSearchList(this.params);
    },
    handleAll2() {
      this.itemList = [];
      this.filterFlag = false;
      this.params.journalsYear = null;
      // 请求全部
      this.getSearchList(this.params);
    },
    handleAll3() {
      this.itemList = [];
      this.filterFlag = false;
      this.params.reportCharge = null;
      // 请求全部
      this.getSearchList(this.params);
    },
    handleAll4() {
      this.itemList = [];
      this.filterFlag = false;
      this.params.xsjhStatus = null;
      // 请求全部
      this.getSearchList(this.params);
    },
    handleInclude(id) {
      this.filterFlag = true;
      if (this.filterFlag) {
        this.pageNum = 1;
        this.itemList = [];
      }
      this.params.dataStyle = id;
      this.getSearchList({
        ...this.params,
      });
    },
    handleYear(item) {
      this.filterFlag = true;
      if (this.filterFlag) {
        this.pageNum = 1;
        this.itemList = [];
      }
      this.params.journalsYear = item;
      this.getSearchList({
        ...this.params,
      });
    },
    async getIncludeList() {
      const resp = await this.$apis.xsjhServe.getIncludeList();
      this.includeList = resp.dbList;
    },
    async getYearList() {
      const resp = await this.$apis.xsjhServe.getYearList();
      this.yearList = resp.yearSet;
    },
  },
};
